// src/App.js
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import OptionsGraphWithMultiStrikeSlider from './OptionsGraphWithMultiStrikeSlider';
import OptionsTableWithMultiStrikes from './OptionsTableWithMultiStrikes';
import OptionsForecastChart from './OptionsForecastChart';
import OptionsGraphForecast from './OptionsGraphForecast';

const App = () => (
  <Routes>
    <Route path="/" element={<OptionsGraphWithMultiStrikeSlider />} />
    <Route path="/table" element={<OptionsTableWithMultiStrikes />} />
    <Route path="/forecast_chart" element={<OptionsForecastChart />} />
    <Route path="/forecast" element={<OptionsGraphForecast />} />
    <Route path="*" element={<Navigate to="/" />} />
  </Routes>
);

export default App;
